import styled, { css } from 'styled-components';
import { PillCustomWrapper } from '@/app/common/components/Pill/styled.ts';

export const FloatingLayoutContainer = styled.div<{ isDark?: boolean }>`
  display: flex;
  border-radius: 24px;

  ${PillCustomWrapper} {
    color: inherit;
    position: relative;

    &:after {
      content: '';
      width: 1px;
      background-color: ${({ isDark, theme }) =>
        isDark ? theme.kallisto.color.text.static.textSecondary : theme.kallisto.color.common.black[100]};
      height: 20px;
      display: block;
      position: absolute;
      left: 100%;
      top: 10px;
      z-index: 1;
    }

    &:last-child {
      &:after {
        content: unset;
      }
    }

    &:has(button:focus-visible) {
      z-index: 2;

      &:after {
        z-index: -1;
      }
    }
  }

  && ${PillCustomWrapper}:not(.selected) button:not([data-pill-clear]) {
    &,
    &:hover {
      border-color: transparent;
    }
  }

  ${({ isDark, theme }) =>
    isDark
      ? css`
          background-color: ${theme.kallisto.color.text.static.textPrimary};
          color: white;

          ${PillCustomWrapper}:after {
            top: 12px;
          }

          && ${PillCustomWrapper} button:not([data-pill-clear]) {
            height: 44px;
            padding: 11px;
            gap: 8px;

            > span:first-of-type {
              padding: 0;
            }
          }

          && ${PillCustomWrapper}:first-child button:not([data-pill-clear]) {
            padding-left: 15px;
          }

          && ${PillCustomWrapper} + ${PillCustomWrapper} button:not([data-pill-clear]) {
            padding-left: 12px;
          }

          && ${PillCustomWrapper}:last-child button:not([data-pill-clear]) {
            padding-right: 15px;
          }

          && ${PillCustomWrapper}:not([data-loading]) button {
            background-color: transparent;
            border-color: transparent;
            color: inherit;

            &:not(:focus-visible) {
              box-shadow: none;
            }

            &:hover {
              background-color: transparent;
              border-color: transparent;
              box-shadow: none;
              color: inherit;
            }

            > svg {
              fill: white;
            }

            > span {
              color: inherit;
            }

            span {
              font-weight: ${theme.kallisto.font.weight.bold};
            }
          }
        `
      : css`
          background-color: ${theme.kallisto.color.common.white['1000']};
          box-shadow: ${theme.kallisto.shadow.mediumDownShadow};
        `};
`;
